import Select from 'react-select';
import { selectCustomStyles } from '../../../../../components/common/shared/select.styled';
import { StyledPaymentRowWrraper } from './PaymentRow.styled';
import BllinkTime from '../../../../../components/common/utils/time';

const PaymentRow = ({ inputName, sum, date, initialDate, disabled, onInputChange, onDropdownChange }) => {  
    const dateObj = new Date(initialDate);
    const currentMonth = dateObj.getMonth() + 1;
    const currentYear = dateObj.getFullYear();
    const currentDay = dateObj.getDate();
    const name = inputName;

    const dropdownOptions = [
        {
            value: `${currentYear}-${currentMonth}-${currentDay}`,
            label: `${currentDay}/${currentMonth}/${currentYear}`,
            name: name
        },
    ];

    const getNextFiveDates = () => {
        let options = [];
        let current = {
            month: +currentMonth,
            year: +currentYear
        };
        for (let i = 0; i < 5; i++) {
            const nextMonth = BllinkTime.getNextMonth(current);
            options.push(nextMonth);
            current = options[options.length-1];
        }
        for (const option of options) {
            dropdownOptions.push({
                value: `${option.year}-${option.month}-${currentDay}`,
                label: `${currentDay}/${option.month}/${option.year}`,
                name: name,
            })
        }
    };

    const getPreviousFiveDates = () => {
        let options = [];
        let current = {
            month: +currentMonth,
            year: +currentYear
        };
        for (let i = 0; i < 5; i++) {
            const previousMonth = BllinkTime.getPreviousMonth(current);
            options.push(previousMonth);
            current = options[options.length - 1];
        }
        for (const option of options) {
            dropdownOptions.unshift({
                value: `${option.year}-${option.month}-${currentDay}`,
                label: `${currentDay}/${option.month}/${option.year}`,
                name: name,
            })
        }
    };

    getNextFiveDates();
    getPreviousFiveDates();

    return (
        <StyledPaymentRowWrraper>
            <input
                type="text"
                className="form-control"
                name={name}
                value={sum}
                disabled={disabled}
                onChange={onInputChange}
            />
            <Select 
                styles={selectCustomStyles}
                className='dropdown' 
                options={dropdownOptions}
                value={date}
                isDisabled={disabled}
                onChange={e => onDropdownChange(e)}
            />       
        </StyledPaymentRowWrraper>
    );
};

export default PaymentRow;
